import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from '../_services/auth.service';
import {UserService} from '../_services/user.service';
import {Observable} from "rxjs";

@Injectable()
export class QuotesGuard implements CanActivate {

    constructor(private authService: AuthService,
                private userService: UserService,
                private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        if (this.authService.loggedIn()) {
            let userData = this.userService.getCurrentUserData();
            if (userData.fleet) {
                this.router.navigate(['/fleet/quotes']);
                return false;
            } else {
                return true;
            }
        }
        return true;
    } // canActivate()
}
